import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import { TextAreaInput } from '../Input';
import Button from '../Button';
import colors from '../../styles/colors';

import {
  CREATE_SMS_TEMPLATE,
  DELETE_SMS_TEMPLATE,
  UPDATE_SMS_TEMPLATE,
} from '../../graphql/queries';
import { AppContext } from '../../context/AppContext';
import BaseModal, { ModalList } from '../modals/BaseModal';

const Form = styled.form`
  padding: 0px 20px;
  width: 700px;

  @media screen and (max-width: 991px) {
    width: clamp(50px,75vw, 700px);
  }
`;

const InputHeaderText = styled.p`
  color: ${colors.grey2};
  font-size: 13px;
`;

const InputHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 20px;
`;

const ButtonContainer = styled.div`
  margin: 20px 0px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${(props) => (props.noBorder ? null : ` border: 1px solid ${colors.grey5}`)};
  border-radius: 7px;
  min-height: 40px;
  justify-content: ${(props) => (props.justify ? props.justify : 'flex-end')};
  padding: 0 30px;

  @media screen and (max-width: 768px) {
    margin: 10px 0px;
    padding: 0;
    height: ${(props) => (props.height ? props.height : 'auto')};
  }
`;
export default function TemplateForm({ editData, close }) {
  const [text, setText] = useState('');
  const { app } = useContext(AppContext);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);

  useEffect(() => {
    if (editData) {
      setText(editData.text);
    }
  }, [editData]);

  const [createSmsTemplate, { loading: createTemplateLoading }] = useMutation(
    CREATE_SMS_TEMPLATE,
    {
      variables: {
        text,
      },
      onError(error) {
        close();
        console.error(error);
      },
      onCompleted() {
        app.refetchTemplates();

        close();
      },
    },
  );

  const [updateSmsTemplate, { loading: updateTemplateLoading }] = useMutation(
    UPDATE_SMS_TEMPLATE,
    {
      variables: {
        campaignTemplateId: editData?._id,
        text,
      },
      onError(error) {
        close();
        console.error(error);
      },
      onCompleted() {
        app.refetchTemplates();

        close();
      },
    },
  );

  const [deleteSmsTemplate, { loading: deleteTemplateLoading }] = useMutation(
    DELETE_SMS_TEMPLATE,
    {
      variables: {
        campaignTemplateId: editData?._id,
        text,
      },
      onError(error) {
        close();
        console.error(error);
      },
      onCompleted() {
        app.refetchTemplates();

        close();
      },
    },
  );

  const onSubmit = (e) => {
    e.preventDefault();
    if (editData) {
      updateSmsTemplate();
      return;
    }

    createSmsTemplate();
  };

  return (
    <>
      <BaseModal
        open={deleteConfirmVisible}
        modalType={ModalList.DeleteTemplateModal}
        onClose={setDeleteConfirmVisible}
        onConfirm={() => deleteSmsTemplate()}
        loading={deleteTemplateLoading}
        header="Are you sure you want to delete the Template?"
        info={editData?.text}
      />
      <Form onSubmit={onSubmit}>
        <InputHeader>
          <InputHeaderText>Template</InputHeaderText>
          <InputHeaderText>Characters: {text.length}</InputHeaderText>
        </InputHeader>
        <TextAreaInput
          width="100%"
          onChange={(e) => setText(e.target.value)}
          value={text || ''}
          required
        />
        <ButtonContainer

          justify={editData && 'space-around'}
          noBorder
        >
          {editData && (
            <Button

              background="red"
              width="30%"
              text="Delete"
              type="button"
              onClick={() => setDeleteConfirmVisible(true)}
            />
          )}

          <Button
            width="30%"
            text={editData ? 'Update' : 'Create'}
            type="submit"
            loading={createTemplateLoading || updateTemplateLoading}
          />
        </ButtonContainer>
      </Form>
    </>
  );
}
